import { ImageBackground, Pressable } from 'react-native'

export function ImageButton({
  image,
  blankElement,
  onPress
}: {
  image: string
  blankElement?: React.ReactElement
  onPress: () => void
}) {
  return (
    <>
      <Pressable
        className={'h-20 flex-1 items-center justify-center overflow-hidden rounded-lg bg-background-secondary'}
        onPress={onPress}
      >
        {image !== undefined ? (
          <ImageBackground source={{ uri: image }} resizeMode={'cover'} className={'size-full'} />
        ) : (
          blankElement
        )}
      </Pressable>
    </>
  )
}

// function PreviewImage({ uri }: { uri: string }) {
//   const { width: windowWidth, height: windowHeight } = useWindowDimensions()
//   const { top } = useSafeAreaInsets()
//   const [width, setWidth] = useState(0)
//   const [height, setHeight] = useState(0)

//   if (uri === '') {
//     return null
//   }
//   Image.getSize(uri, (width: number, height: number) => {
//     setWidth(width)
//     setHeight(height)
//   })
//   const containerWidth = windowWidth - 16 - 16
//   const containerHeight = windowHeight - top - 44 - 44 - 34
//   const scaleRatio = Math.min(containerWidth / width, containerHeight / height, 1)
//   return <Image source={{ uri }} style={{ width: width * scaleRatio, height: height * scaleRatio }} />
// }

// export function CameraModal({
//   addImageIndex,
//   addImage,
//   isOpen,
//   handleCloseModal
// }: {
//   addImageIndex: number
//   addImage: (uri: string, index: number, fileName?: string | null, mimeType?: string) => void
//   isOpen: boolean
//   handleCloseModal: () => void
// }) {
//   const { top } = useSafeAreaInsets()
//   const cameraRef = useRef<Camera>(null)
//   const [permission, requestPermission] = Camera.useCameraPermissions()
//   const [tentativeImage, setTentativeImage] = useState<string | null>(null)

//   useEffect(() => {
//     if (!isOpen || !permission || permission.granted) {
//       return
//     }
//     if (permission.canAskAgain) {
//       requestPermission()
//     }
//   }, [isOpen, permission, requestPermission])

//   async function takePhoto() {
//     if (cameraRef.current) {
//       const pic = await cameraRef.current.takePictureAsync()
//       setTentativeImage(pic.uri)
//     }
//   }

//   function handleGoBackToCamera() {
//     setTentativeImage(null)
//   }

//   function confirmImage() {
//     if (tentativeImage === null || addImageIndex === -1) {
//       return
//     }
//     addImage(tentativeImage, addImageIndex)
//     setTentativeImage(null)
//     handleCloseModal()
//   }

//   if (!permission || !permission.granted) {
//     return (
//       <Modal visible={isOpen} animationType={'slide'} transparent={true}>
//         <View className={'flex-1 bg-black'}>
//           <View className={'flex-1'}>
//             <View className={'flex-row items-center bg-black px-2'} style={{ height: 44 + top, paddingTop: top }}>
//               <Pressable className={'size-10 items-center justify-center'} onPress={handleCloseModal}>
//                 <Close className={'size-6 text-white'} />
//               </Pressable>
//             </View>
//           </View>
//           <View className={'items-center justify-center'}>
//             <Text className={'text-white'}>{'No Access'}</Text>
//           </View>
//           <View className={'flex-1'} />
//         </View>
//       </Modal>
//     )
//   }

//   return (
//     <Modal visible={isOpen} animationType={'slide'} transparent={true}>
//       <View className={'flex-1 bg-black'} style={{ borderWidth: 10 }}>
//         <View className={'flex-row items-center bg-black px-2'} style={{ height: 44 + top, paddingTop: top }}>
//           <Pressable
//             className={'size-10 items-center justify-center'}
//             onPress={tentativeImage === null ? handleCloseModal : handleGoBackToCamera}
//           >
//             {tentativeImage === null ? (
//               <Close className={'size-6 text-white'} />
//             ) : (
//               <ArrowBack className={'size-6 text-white'} />
//             )}
//           </Pressable>
//         </View>
//         {tentativeImage === null ? (
//           <View className={'flex-1'}>
//             <Camera style={{ flex: 1 }} ref={cameraRef} type={CameraType.back}>
//               <View className={'absolute bottom-2 left-0 right-9 items-center'}>
//                 <Shutter onPress={takePhoto} />
//               </View>
//             </Camera>
//           </View>
//         ) : (
//           <View className={'flex-1 items-center justify-center'}>
//             <PreviewImage uri={tentativeImage} />
//           </View>
//         )}

//         <View className={'h-11 flex-row items-center justify-end bg-black px-2'}>
//           {tentativeImage !== null && (
//             <Pressable className={'size-10 items-center justify-center'} onPress={confirmImage}>
//               <Check className={'size-6 text-white'} />
//             </Pressable>
//           )}
//         </View>
//         <View className={'h-[34px]'} />
//       </View>
//     </Modal>
//   )
// }

// function Shutter(props: PressableProps) {
//   return (
//     <Pressable {...props}>
//       {({ pressed }) => (
//         <View className={'size-20 items-center justify-center rounded-full border-4 border-background-primary'}>
//           <View className={cn('size-16 rounded-full bg-background-primary', pressed && 'opacity-50')} />
//         </View>
//       )}
//     </Pressable>
//   )
// }
